<template>
	<div class="infoall margin-left">
		<div class="topinfo bg-white flex align-center justify-between" v-if="is_real == 3">
			<div>
				<div class="ytpe text-left">已实名认证</div>
				<div class="text-df text-666 margin-top-sm">完成实名认证，招工找活快人一步！</div>
			</div>
			<div class="btnhome pointer" @click="golink('home')">去首页 <i class="el-icon-arrow-right"></i></div>
		</div>
		<div class="topinfo bg-white flex align-center justify-between" v-else>
			<div>
				<div class="ytpe text-left">未实名认证</div>
				<div class="text-df text-666 margin-top-sm">完成实名认证，招工找活快人一步！</div>
			</div>
			<div class="btnhome pointer" @click="gettype('idcard')">去实名 <i class="el-icon-arrow-right"></i></div>
		</div>
		<div class="bg-white margin-top info">
			<div class="flex align-start">
				<div class="title-p">头像</div>
				<!-- <div>
					<p class="headerw">
						<img class="thumb" :src="avatar" >
						<img class="camera" src="../../assets/img/camera.png" >
					</p>
					<p>点击更换头像</p>
				</div> -->
				<div class="">
					<el-upload
					  class="avatar-uploader"
					  action="https://manage.ciiply.com/api/pc/user/upFile"
					  :show-file-list="false"
					  :on-success="handleSuccess">
					  <p class="headerw">
					  	<img class="thumb" :src="avatar" >
					  	<img class="camera" src="../../assets/img/camera.png" >
					  </p>
					  <p class="text-999">点击更换头像</p>
					  <!-- <img v-if="firstimg" :src="firstimg" class="uploadimg">
					  <img v-else class="uploadimg" src="https://wz89.lzym.top/web/static/home/add.png"> -->
					</el-upload>
				</div>
			</div>
			<div class="flex align-center margin-top">
				<div class="title-p">昵称</div>
				<div class="case">
					<input type="text" placeholder="请填写" v-model="nick_name"/>
				</div>
			</div>
			<div class="flex align-center margin-top-xs">
				<div class="title-p">性别</div>
				<el-select class="cases" v-model="sexName" placeholder="请选择性别" @change="changesex">
				      <el-option label="保密" value="0"></el-option>
				      <el-option label="男" value="1"></el-option>
				      <el-option label="女" value="2"></el-option>
				</el-select>
			</div>
			<div class="flex align-center margin-top">
				<div class="title-p">年龄</div>
				<div class="case">
					<input type="number" placeholder="请填写" v-model="age"/>
				</div>
			</div>
			<div class="flex align-center margin-top">
				<div class="title-p">民族</div>
				<div class="case">
					<input type="text" placeholder="请填写" v-model="nation"/>
				</div>
			</div>
			<div class="flex align-center margin-top-xs">
				<div class="title-p">绑定手机</div>
				<div class="case">
					<div class="text-left">{{phone | filterMobile}}</div>
				</div>
			</div>
			<div class="flex align-center justify-center pointer" @click="submit">
				<div class="preup text-white">保存更新</div>
			</div>
			<p class="margin-top-sm">如有疑问请联系平台客服：400-212-22</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data() {
			return {
				sex: [{
					name: "保密",
					id: 0
				}, {
					name: "男",
					id: 1
				}, {
					name: "女",
					id: 2
				}], // {Array} 性别数组
				age:'',
				nation:'',
				nick_name:'',
				sexIndex:0,
				phone: '',// 手机号
				sexName:'',
				avatar:'',
				is_real: 1,
			}
		},
		computed: {
			userInfo() {
				if (this.$store.getters.userInfo) {
					return this.$store.getters.userInfo;
				} else {
					return JSON.parse(localStorage.getItem('USER_INFO'));
				}
			},
			// sexIndex(){
			// 	let val = this.sexName
			// 	console.log(val);
			// 	switch (val) {
			// 		case '保密':
			// 			return 0;
			// 		case '男':
			// 			return 1;
			// 		case '女':
			// 			return 2;
			// 		default:
			// 			return '';
			// 	}
			// }
			// sexName() {
			// 	let name = this.sex[this.sexIndex].name;
			
			// 	return name;
			// },
		},
		created() {
			this.getinfo()
		},
		filters:{
			/**
			 * @description 手机号过滤中间四位用*代替
			 * @param {Number,String} val 手机号
			 */
			filterMobile(val) {
			  if (!val) return '';
			  return val.substr(0, 3) + '****' + val.substr(-4);
			}
		},
		methods: {
			//通知center 跳转对应页面
			gettype(index,typeone){
				let one = typeone?typeone:''
				let type = {
					type:index,
					typeone:one
				}
				this.$emit('gettype',type)
			},
			/**
			 * 跳转页面
			 * name   string   页面路由
			 * type   string   页面传参判断个人中心显示组件
			 * */
			golink(name,type){
				let query = {}
				if(type){
					query.type = type
				}
				this.$router.push({
					name:name,
					query
				})
			},
			//上转第一张
			handleSuccess(file){
				this.avatar = file.data.url;
			},
			getReal(){
				this.ajax('get', '/api/userReal/getReal', {
					type: 1
				}, res => {
					console.log(res);
					if (res.status == 200) {
						this.is_real = res.data.is_real
						
					} else {
						
					}
				})
			},
			changesex(){
				this.sexIndex = this.sexName;
			},
			getinfo(){
				this.ajax('get', '/api/userInfo/myUserInfo', { }, res => {
					console.log(res);
					if (res.status == 200) {
						this.age = res.data.user.age
						this.nation = res.data.user.nation
						this.nick_name = res.data.user.nick_name
						// this.sexName = res.data.user.sex
						this.sexIndex = res.data.user.sex
						this.sexName = this.sex[this.sexIndex].name;
						this.phone = res.data.user.phone
						this.avatar = res.data.user.avatar
						
					} else {
						
					}
				})
			},
			submit(){
				// return console.log(this.sexName);
				this.ajax('post', '/api/pc/user/editInfo', {
					nick_name: this.nick_name,
					sex: this.sexIndex,
					age:this.age,
					avatar:this.avatar,
					nation:this.nation
				}, res => {
					console.log(res);
					if (res.status == 200) {
						this.$store.commit('updateUserInfo',res.data);
						this.getinfo()
						this.$message('保存成功');
						
					} else {
						
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.infoall{
		width: 921px;
	}
	.topinfo{
		width: 921px;
		height: 162px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 20px;
		padding: 0 42px;
		.ytpe{
			font-size: 36px;
			font-weight: bold;
			color: #09827B;
		}
		.btnhome{
			width: 138px;
			height: 48px;
			line-height: 48px;
			background: rgba(11,131,124,0.1000);
			border: 1px solid #0B837C;
			border-radius: 24px;
			color: #0B837C;
		}
	}
	.headerw{
		position: relative;
		width: 128px;
		height: 108px;
		border-radius: 8px;
		.thumb{
			position: absolute;
			top: 0;
			left: 0;
			width: 128px;
			height: 108px;
			border-radius: 8px;
		}
		.camera{
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			width: 47px;
			height: 36px;
		}
	}
	.cases{
		width: 444px;
		height: 54px;
		border-radius: 8px;
		border: 1px solid #E6E6E6;
		
	}
	/deep/ .el-input__inner{
			width: 425px;
			height: 49px;
			border-radius: 8px;
			padding-left: 10px;
			border: 0;
		}
	.case{
		width: 444px;
		height: 54px;
		border: 1px solid #E6E6E6;
		border-radius: 8px;
		input{
			width: 425px;
			height: 49px;
			border-radius: 8px;
			padding-left: 10px;
		}
		div{
			padding-left:15px ;
			line-height: 54px;
		}
	}
	.title-p{
		width: 100px;
	}
	.preup{
		width: 383px;
		height: 60px;
		line-height: 60px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9,130,123,0.2000);
		border-radius: 30px;
		margin-top: 100px;
	}
	input{
		outline: 0;
		border: 0;
	}
	.info{
		width: 921px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 20px;
		padding: 50px 185px;
	}
</style>



// WEBPACK FOOTER //
// src/view/my/setinfo.vue